module.exports = __webpack_public_path__ + "static/media/studentPlans.34dc2a33.png";